export enum EDeleteResponseSummaryStatus {
    ERROR = 'ERROR',
    OK = 'OK',
    UNDEFINED = 'UNDEFINED',
    WARNING = 'WARNING'
}

export type TResponseStatus = EDeleteResponseSummaryStatus;

export enum EResponseEntityCode {
    FNS_REFRESH_TOKEN_TIME = 'FNS_REFRESH_TOKEN_TIME',
}
